import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import { ALCOHOL_NOTICE, formatMoney, SITE_CONFIG } from "../config/siteConfig";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, quantity, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  return (
    <div className="product-detail">
      <div className="product-detail__content">
        <div className="product-detail__gallery">
          <div className="product-detail__main-image">
            <img src={product.images[selectedImage]} alt={product.name} />
          </div>
          {product.images.length > 1 && (
            <div className="product-detail__thumbnails">
              {product.images.map((img, idx) => (
                <button
                  type="button"
                  key={idx}
                  className={`product-detail__thumbnail ${
                    selectedImage === idx ? "active" : ""
                  }`}
                  onClick={() => setImage(idx)}
                  aria-label={`Show ${product.name} image ${idx + 1}`}
                  aria-pressed={selectedImage === idx}
                >
                  <img src={img} alt={`${product.name} ${idx + 1}`} />
                </button>
              ))}
            </div>
          )}
        </div>

        <div className="product-detail__info">
          <p className="product-detail__brand">{SITE_CONFIG.brand}</p>
          <h1 className="product-detail__title">{product.name}</h1>
          <p className="product-detail__price">{formatMoney(product.price)}</p>
          <p className="product-detail__stock">{product.stock} available</p>

          {product.colors && product.colors.length > 0 && (
            <div className="product-detail__section">
              <span className="product-detail__label">Colour</span>
              <div className="product-detail__options">
                {product.colors.map((color, index) => (
                  <button
                    key={index}
                    className={`product-detail__option-btn ${
                      selectedColor === color ? "active" : ""
                    }`}
                    onClick={() => setSelectedColor(color)}
                  >
                    {color}
                  </button>
                ))}
              </div>
            </div>
          )}

          {product.size &&
            product.size.length > 0 &&
            product.size[0] !== "One size" && (
              <div className="product-detail__section">
                <span className="product-detail__label">Size</span>
                <div className="product-detail__options">
                  {product.size.map((size, index) => (
                    <button
                      key={index}
                      className={`product-detail__option-btn ${
                        selectedSize === size ? "active" : ""
                      }`}
                      onClick={() => setSelectedSize(size)}
                    >
                      {size}
                    </button>
                  ))}
                </div>
              </div>
            )}

          <div className="product-detail__section">
            <span className="product-detail__label">Quantity</span>
            <div className="product-detail__quantity">
              <button
                className="product-detail__qty-btn"
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
              >
                -
              </button>
              <span className="product-detail__qty-value">{quantity}</span>
              <button
                className="product-detail__qty-btn"
                onClick={() => setQuantity(Math.min(product.stock, quantity + 1))}
                disabled={quantity >= product.stock}
              >
                +
              </button>
            </div>
          </div>

          <div className="product-detail__actions">
            <button
              className="product-detail__add-btn"
              onClick={handleAddToCart}
            >
              Add to cart
            </button>
          </div>

          {product.description && product.description.length > 0 && (
            <div className="product-detail__description">
              <p><strong>Material:</strong> {product.material}</p>
              {product.description.map((desc, index) => (
                <p key={index}>{desc}</p>
              ))}
            </div>
          )}

          {product.alcohol && (
            <p className="product-detail__alcohol-notice">
              {ALCOHOL_NOTICE}
            </p>
          )}

          {product.Features && product.Features.length > 0 && (
            <div className="product-detail__features">
              <ul>
                {product.Features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
